import React from "react";
import Style from "./index.module.scss";
import { Tooltip } from "antd";

export function overFlow(text: string, children?: React.ReactChild) {
    const node = <p className={Style.text}>{text}</p>;
    return <Tooltip title={text}>{children || node}</Tooltip>;
}
